import { ElementNode, $createTextNode } from 'lexical';

export class FontSizeNode extends ElementNode {
  __fontSize;

  // eslint-disable-next-line default-param-last
  constructor(fontSize = '16px', nodeKey) {
    // Provide default font size so constructor can be called without arguments
    super(nodeKey);
    this.__fontSize = fontSize;
  }

  static getType() {
    return 'fontSize';
  }

  static clone(node) {
    return new FontSizeNode(node.__fontSize, node.__key);
  }

  static importJSON(serializedNode) {
    // eslint-disable-next-line no-use-before-define
    const node = $createFontSizeNode('', serializedNode.fontSize);
    // Lexical will handle importing children if they exist
    return node;
  }

  exportJSON() {
    const json = {
      type: 'fontSize',
      version: 1,
      fontSize: this.__fontSize,
    };

    // Lexical will handle serializing children
    const children = this.getChildren();
    if (children.length > 0) {
      // Let Lexical handle the serialization
      // eslint-disable-next-line no-underscore-dangle
      json.children = children.map((child) => child.exportJSON());
    } else {
      json.children = [];
    }

    return json;
  }

  createDOM() {
    const span = document.createElement('span');
    span.style.fontSize = this.__fontSize;
    return span;
  }

  updateDOM(prevNode, dom) {
    if (prevNode.__fontSize !== this.__fontSize) {
      // eslint-disable-next-line no-param-reassign
      dom.style.fontSize = this.__fontSize;
    }
    return false;
  }

  getFontSize() {
    return this.__fontSize;
  }

  setFontSize(fontSize) {
    const writable = this.getWritable();
    writable.__fontSize = fontSize;
  }
}

// Factory function
export function $createFontSizeNode(text = '', fontSize = '16px') {
  const node = new FontSizeNode(fontSize);
  if (text) {
    node.append($createTextNode(text));
  }
  return node;
}

export function $isFontSizeNode(node) {
  return node instanceof FontSizeNode;
}
